import { Grid, Pagination, Stack } from "@mui/material";
import React, { useState } from "react";
import { TestLLMClassifierOnConversationResult } from "models/LLMs/Testing/TestLLMClassifierOnConversationResult";
import { LLMClassifierBuilderStore } from "components/Classifiers/LLMClassifiers/Stores/LLMClassifierBuilderStore";
import { MetadataResultCard } from "./MetadataResultCard";

interface MetadataResultsCardsProps {
    results: TestLLMClassifierOnConversationResult[];
}

export function MetadataResultsCards({ results }: MetadataResultsCardsProps) {
    const [pageNumber, setPageNumber] = useState(1);

    const start =
        (pageNumber - 1) * LLMClassifierBuilderStore.TestingPerSectionPageSize;
    const end = Math.min(
        start + LLMClassifierBuilderStore.TestingPerSectionPageSize,
        results.length,
    );
    const resultsToShow = results.slice(start, end);

    const pageCount = Math.ceil(
        results.length / LLMClassifierBuilderStore.TestingPerSectionPageSize,
    );

    const hasMoreThanOnePage = pageCount > 1;

    return (
        <Stack rowGap={2}>
            {hasMoreThanOnePage && (
                <Grid container justifyContent="center">
                    <Pagination
                        count={pageCount}
                        page={pageNumber}
                        onChange={(_, value) => {
                            setPageNumber(value);
                            window.scrollTo({ top: 0, behavior: "smooth" });
                        }}
                        size="small"
                        showFirstButton
                        showLastButton
                    />
                </Grid>
            )}
            {resultsToShow.map((result, index) => (
                <MetadataResultCard
                    key={result.conversation.id}
                    result={result}
                    number={start + index}
                />
            ))}
            {hasMoreThanOnePage && (
                <Grid container justifyContent="center">
                    <Pagination
                        count={pageCount}
                        page={pageNumber}
                        onChange={(_, value) => {
                            setPageNumber(value);
                            window.scrollTo({ top: 0, behavior: "smooth" });
                        }}
                        size="small"
                        showFirstButton
                        showLastButton
                    />
                </Grid>
            )}
        </Stack>
    );
}
